module.exports = __webpack_public_path__ + "static/media/computer_organisation.bb554d3b.jpeg";